import React from 'react';
import Tagify from '@yaireo/tagify/dist/tagify';
import { useGetCategoriesQuery } from '@/features/categories/categoriesApiSlice';

export const CategoriesInput = ({ categories = [], onUpdateCategories }) => {
  const { data } = useGetCategoriesQuery();
  const categoriesInputRef = React.useRef(null);

  React.useEffect(() => {
    let tagify;
    if (categoriesInputRef.current) {
      const whitelist =
        data?.map((category) => ({
          id: category._id,
          value: category._name,
          count: category._count,
        })) ?? [];
      tagify = new Tagify(categoriesInputRef.current, {
        pattern: /^.{0,40}$/, // Validate typed tag(s) by Regex. Here maximum chars length is defined as "40"
        delimiters: ',',
        templates: {
          tag(tagData) {
            return `<tag title="${
              tagData.value
            }" contenteditable="false" spellcheck="false" class="tagify__tag ${
              tagData.class ? tagData.class : ''
              // eslint-disable-next-line react/no-this-in-sfc
            }" ${this.getAttributes(tagData)}>
					<x title="remove tag" class="tagify__tag__removeBtn" style="height: 20px"></x>
					<div>
						<span class="tagify__tag-text" style="height: 20px">${tagData}</span>
					</div>
				</tag>`;
          },
          dropdownItem(tagData) {
            return `<div class="tagify__dropdown__item ${
              tagData.class ? tagData.class : ''
            }" tagifySuggestionIdx="${tagData.tagifySuggestionIdx}">
						<span>${tagData.value} (${tagData.count})</span>
					</div>`;
          },
        },
        dropdown: {
          enabled: 0,
          maxItems: Infinity,
          highlightFirst: false,
          fuzzySearch: true,
          mapValueTo: '_name',
        },
        editTags: 0,
        autocomplete: true,
        whitelist,
        placeholder: 'Add new or existing categories',
        duplicates: false, // allow adding duplicate tags
        enforceWhitelist: false, // only allow tags that come from whitelist,
      });
      tagify.on('add', (e) => {
        onUpdateCategories('add', e.detail.data);
      });
      tagify.on('remove', (e) => {
        onUpdateCategories('remove', e.detail.data);
      });

      tagify.limitMaxLength = (() => {
        const allowedKeys = [
          'Backspace',
          'Delete',
          'ArrowUp',
          'ArrowDown',
          'ArrowLeft',
          'ArrowRight',
        ];
        // search for the input inside tagify
        const input = document.querySelector('.tagify__input');
        // onkeydown, verify if its textContent length exceeds maximum allowed
        input.onkeydown = (event) => {
          if (
            !allowedKeys.includes(event.key) &&
            input.textContent.length >= 40
          ) {
            event.preventDefault();
          }
        };
      })();
    }

    return () => tagify?.destroy();
  }, [data]);

  return (
    <input
      ref={categoriesInputRef}
      type="text"
      name="trevor-query-categories"
      id="trevor-query-categories"
      className="trevor-tagify-input"
      defaultValue={
        categories.length > 0
          ? JSON.stringify(
              categories.map((c) => ({ id: c._id, value: c._name })),
            )
          : undefined
      }
      autoComplete="off"
    />
  );
};
